import { Product3dModel, Product3dViewer } from '@app-types/product-3d';

import { PRODUCT_3D_VIEWER_PATH } from '@constants/product-3d';

export function mapProduct3dViewer(
    productId: string,
    model: Product3dModel,
    availableColors: string[],
): Product3dViewer | undefined {
    const colors = availableColors.filter((color) => model.colors.some(({ name }) => name === color));

    if (colors.length === 0) {
        return undefined;
    }

    const searchParams = new URLSearchParams(colors.map((color) => ['colors', color]));

    return {
        name: model.name,
        url: `${PRODUCT_3D_VIEWER_PATH}/${productId}?${searchParams}`,
    };
}
